import {Helmet} from "react-helmet";
import React from "react";
import logo from "../../../../assets/images/logo.png";
import './TermsOfUse.js.scss';


const TermsOfUse = () => {

  return (
    <>
      <Helmet>
        <title>Termos de Uso</title>
      </Helmet>
      <div className="TermsOfUse">
        <div className="navbar">
          <img src={logo} alt="Logo" style={{ height: '100%' }} />
        </div>

        <div className="content">
          <h1 className={"header"}>Termos de Uso</h1>
          <>
            <p
              style={{
                marginTop: "0pt",
                marginBottom: "8pt",
                textAlign: "justify",
                lineHeight: "150%"
              }}
            >
              &nbsp;
            </p>
            <p
              style={{
                marginTop: "0pt",
                marginBottom: "8pt",
                textAlign: "justify",
                lineHeight: "150%"
              }}
            >
              Os presentes termos e condições de uso visam regular a utilização por você,
              usuário, de nossos serviços pelas plataformas, sites ou aplicativos da{" "}
              <strong>CLAPTICKETS</strong>
            </p>
            <p
              style={{
                marginTop: "0pt",
                marginBottom: "8pt",
                textAlign: "justify",
                lineHeight: "150%"
              }}
            >
              Não nos responsabilizamos por danos a terceiros que decorram de falhas de
              acesso, transmissão, difusão ou disponibilização de conteúdo e de serviços
              do portal;
            </p>
            <p
              style={{
                marginTop: "0pt",
                marginBottom: "8pt",
                textAlign: "justify",
                lineHeight: "150%"
              }}
            >
              A oferta de serviços e/ou conteúdo desse portal obedecem a critérios de
              acessibilidade;
            </p>
            <p
              style={{
                marginTop: "0pt",
                marginBottom: "8pt",
                textAlign: "justify",
                lineHeight: "150%"
              }}
            >
              &nbsp;
            </p>
            <p
              style={{
                marginTop: "0pt",
                marginBottom: "8pt",
                textAlign: "justify",
                lineHeight: "150%"
              }}
            >
              <strong>Termo de Aceitação</strong>
            </p>
            <p
              style={{
                marginTop: "0pt",
                marginBottom: "8pt",
                textAlign: "justify",
                lineHeight: "150%"
              }}
            >
              Ao utilizar os nossos Serviços, o usuário aceita e concorda com todos os
              termos e condições expostas que se encontram vigentes na data.
            </p>
            <p
              style={{
                marginTop: "0pt",
                marginBottom: "8pt",
                textAlign: "justify",
                lineHeight: "150%"
              }}
            >
              Alertamos que estes Termos e Condições de Uso poderão ser modificados a
              qualquer momento, em virtude de alterações na legislação ou nos Serviços, em
              decorrência da utilização de novas ferramentas tecnológicas ou, ainda,
              sempre que, a exclusivo critério da <strong>CLAPTICKETS</strong>, tais
              alterações se façam necessárias.
            </p>
            <p
              style={{
                marginTop: "0pt",
                marginBottom: "8pt",
                textAlign: "justify",
                lineHeight: "150%"
              }}
            >
              A utilização dos Serviços online disponibilizados pelo critério da{" "}
              <strong>CLAPTICKETS</strong> por qualquer usuário implicará em expressa
              aceitação destes Termos e Condições de Uso, bem como na autorização para
              serem contactados, pelos mais diversos meios possíveis para receber
              notícias, informações e convite para se tornarem dizimistas e devotos.
            </p>
            <p
              style={{
                marginTop: "0pt",
                marginBottom: "8pt",
                textAlign: "justify",
                lineHeight: "150%"
              }}
            >
              <strong>&nbsp;</strong>
            </p>
            <p
              style={{
                marginTop: "0pt",
                marginBottom: "8pt",
                textAlign: "justify",
                lineHeight: "150%"
              }}
            >
              <strong>Tratamento de Informações</strong>
            </p>
            <p
              style={{
                marginTop: "0pt",
                marginBottom: "8pt",
                textAlign: "justify",
                lineHeight: "150%"
              }}
            >
              A sua privacidade e o sigilo de suas informações são muito importantes.
              Tomamos os cuidados necessários para garantir a proteção de seus dados
              pessoais, o sigilo e o uso adequado dos seus dados pessoais.
            </p>
            <p
              style={{
                marginTop: "0pt",
                marginBottom: "8pt",
                textAlign: "justify",
                lineHeight: "150%"
              }}
            >
              A <strong>CLAPTICKETS</strong> se compromete a cumprir as normas previstas
              na LGPD e a realizar o tratamento de dados pessoais em conformidade com os
              seguintes princípios:
            </p>
            <p
              style={{
                marginTop: "0pt",
                marginLeft: "70.8pt",
                marginBottom: "8pt",
                textAlign: "justify",
                lineHeight: "150%"
              }}
            >
              a) apenas para as finalidades determinadas nessa política, valendo-se da
              quantidade adequada de dados, pertinentes e limitados à necessidade e
              objetivo do tratamento;
            </p>
            <p
              style={{
                marginTop: "0pt",
                marginLeft: "70.8pt",
                marginBottom: "8pt",
                textAlign: "justify",
                lineHeight: "150%"
              }}
            >
              b) de forma transparente, sendo garantido ao titular dos dados o livre
              acesso, a exatidão dos dados e a sua consulta facilitada;
            </p>
            <p
              style={{
                marginTop: "0pt",
                marginLeft: "70.8pt",
                marginBottom: "8pt",
                textAlign: "justify",
                lineHeight: "150%"
              }}
            >
              c) de forma segura, por meio da adoção de medidas técnicas aptas a proteger
              os dados pessoais, prevenir e mitigar danos decorrentes de eventual acesso
              não autorizado, ou de situação acidental ou ilícita de violação de dados.
            </p>
            <p
              style={{
                marginTop: "0pt",
                marginBottom: "8pt",
                textAlign: "justify",
                lineHeight: "150%"
              }}
            >
              &nbsp;
            </p>
            <p
              style={{
                marginTop: "0pt",
                marginBottom: "8pt",
                textAlign: "justify",
                lineHeight: "150%"
              }}
            >
              A <strong>CLAPTICKETS</strong> realizará a gestão de dados pessoais durante
              o ciclo de vida destas informações; e em hipótese alguma haverá tratamento
              de dados para fins discriminatórios ilícitos ou abusivos.
            </p>
            <p
              style={{
                marginTop: "0pt",
                marginBottom: "8pt",
                textAlign: "justify",
                lineHeight: "150%"
              }}
            >
              Os dados cadastrados neste portal são criptografados.
            </p>
            <p
              style={{
                marginTop: "0pt",
                marginBottom: "8pt",
                textAlign: "justify",
                lineHeight: "150%"
              }}
            >
              O envio de mensagens ao correio eletrônico do usuário só será feito mediante
              aceitação do internauta ao disponibilizar seu endereço de e-mail, nome e
              telefone, que poderá, a qualquer momento, requerer o cancelamento do envio
              de informações;
            </p>
            <p
              style={{
                marginTop: "0pt",
                marginBottom: "8pt",
                textAlign: "justify",
                lineHeight: "150%"
              }}
            >
              O portal faz uso de cookies (informações enviadas pelo servidor de
              hospedagem do portal ao computador do usuário, para identificá-lo) para
              processar consultas em determinadas bases de dados e realizar operações que
              requeiram o controle de envio de dados pelo usuário;
            </p>
            <p
              style={{
                marginTop: "0pt",
                marginBottom: "8pt",
                textAlign: "justify",
                lineHeight: "150%"
              }}
            >
              Podemos, a qualquer momento e sem aviso prévio aos usuários, alterar ou
              extinguir qualquer conteúdo desse portal, bem como mudar sua concepção
              visual e estrutura de conteúdo.
            </p>
            <p
              style={{
                marginTop: "0pt",
                marginBottom: "8pt",
                textAlign: "justify",
                lineHeight: "150%"
              }}
            >
              &nbsp;
            </p>
            <p
              style={{
                marginTop: "0pt",
                marginBottom: "8pt",
                textAlign: "justify",
                lineHeight: "150%"
              }}
            >
              <strong>Responsabilidade dos Usuários</strong>
            </p>
            <p
              style={{
                marginTop: "0pt",
                marginBottom: "8pt",
                textAlign: "justify",
                lineHeight: "150%"
              }}
            >
              Vedado ao usuário transmitir ou difundir ameaças, pornografia infantil e
              conteúdo que induzam à violência ou a qualquer tipo de discriminação, seja
              ela sexual, racial, étnica, religiosa, política, etária, social;
            </p>
            <p
              style={{
                marginTop: "0pt",
                marginBottom: "8pt",
                textAlign: "justify",
                lineHeight: "150%"
              }}
            >
              Vedado ao usuário promover atos que contenham calúnia, injúria e difamação;
            </p>
            <p
              style={{
                marginTop: "0pt",
                marginBottom: "8pt",
                textAlign: "justify",
                lineHeight: "150%"
              }}
            >
              Vedado ao usuário transmitir tipos ou quantidades de dados que causem falhas
              em serviços ou equipamentos do portal e/ou de terceiros;
            </p>
            <p
              style={{
                marginTop: "0pt",
                marginBottom: "8pt",
                textAlign: "justify",
                lineHeight: "150%"
              }}
            >
              No caso de serviços que requeiram registro, o usuário se compromete em
              transmitir informações pessoais verdadeiras e completas;
            </p>
            <p
              style={{
                marginTop: "0pt",
                marginBottom: "8pt",
                textAlign: "justify",
                lineHeight: "150%"
              }}
            >
              Vedado ao usuário utilizar a rede para tentar e/ou realizar acesso não
              autorizado a dispositivos de comunicação, informação ou computação;
            </p>
            <p
              style={{
                marginTop: "0pt",
                marginBottom: "8pt",
                textAlign: "justify",
                lineHeight: "150%"
              }}
            >
              Vedado ao usuário distribuir, via correio eletrônico, grupos de discussão ou
              quaisquer outros canais interativos de participação, mensagens não
              solicitadas do tipo “corrente” e mensagens em massa, comerciais ou não.
            </p>
            <p
              style={{
                marginTop: "0pt",
                marginBottom: "8pt",
                textAlign: "justify",
                lineHeight: "150%"
              }}
            >
              O usuário se responsabiliza pela precisão e veracidade dos dados informados
              e reconhece que a inconsistência destes poderá implicar a impossibilidade de
              acessar o Site e/ou Aplicativo, além das sanções administrativas, civis, e
              penais previstas na legislação brasileira, em especial na tributária e
              administrativa.
            </p>
            <p
              style={{
                marginTop: "0pt",
                marginBottom: "8pt",
                textAlign: "justify",
                lineHeight: "150%"
              }}
            >
              &nbsp;
            </p>
            <p
              style={{
                marginTop: "0pt",
                marginBottom: "8pt",
                textAlign: "justify",
                lineHeight: "150%"
              }}
            >
              <strong>Sobre uso de cookies</strong>
            </p>
            <p
              style={{
                marginTop: "0pt",
                marginBottom: "8pt",
                textAlign: "justify",
                lineHeight: "150%"
              }}
            >
              O que são esses cookies?
            </p>
            <p
              style={{
                marginTop: "0pt",
                marginBottom: "8pt",
                textAlign: "justify",
                lineHeight: "150%"
              }}
            >
              Tratam-se de arquivos criados pelos websites que armazenam hábitos de
              navegação e outras informações, ajudando a personalizar seu acesso. Exemplo:
              você acessa o site e visualiza um banner pop-up com um aviso importante e
              clica no botão "Não tenho interesse", ao fechar aquele banner o site
              armazena que você já visualizou e da próxima vez que entrar no site você não
              é mais incomodado com aquele aviso.
            </p>
            <p
              style={{
                marginTop: "0pt",
                marginBottom: "8pt",
                textAlign: "justify",
                lineHeight: "150%"
              }}
            >
              E não é perigoso ter minhas informações armazenadas? Não é perigoso. Todas
              as suas informações coletadas em nosso site servem apenas para melhorar a
              sua experiência e são protegidas por nosso sistema de segurança.
            </p>
            <p
              style={{
                marginTop: "0pt",
                marginBottom: "8pt",
                textAlign: "justify",
                lineHeight: "150%"
              }}
            >
              Não gosto de cookies, como faço para desativá-los? É possível desativar os
              cookies por meio das preferências do seu navegador. Sem eles sua navegação
              pode se tornar limitada e algumas funcionalidades dos sites podem ficar
              comprometidas. Por sua vez, a utilização dos cookies dependerá de sua
              concordância, com manifestação de consentimento através da opção “Concordo”
            </p>
            <p
              style={{
                marginTop: "0pt",
                marginBottom: "8pt",
                textAlign: "justify",
                lineHeight: "150%"
              }}
            >
              Veja as definições sobre cookies em cada um dos navegadores: Internet
              Explorer /
            </p>
            <p
              style={{
                marginTop: "0pt",
                marginBottom: "8pt",
                textAlign: "justify",
                lineHeight: "150%"
              }}
            >
              Firefox / Google Chrome / Safari / Opera
            </p>
            <p
              style={{
                marginTop: "0pt",
                marginBottom: "8pt",
                textAlign: "justify",
                lineHeight: "150%"
              }}
            >
              &nbsp;
            </p>
            <p
              style={{
                marginTop: "0pt",
                marginBottom: "8pt",
                textAlign: "justify",
                lineHeight: "150%"
              }}
            >
              <strong>Lei Geral de Proteção de Dados Pessoais (LGPD)</strong>
            </p>
            <p
              style={{
                marginTop: "0pt",
                marginBottom: "8pt",
                textAlign: "justify",
                lineHeight: "150%"
              }}
            >
              Lei 13.709 de 14.08.2018 O que é a Lei Geral de Proteção de Dados? É uma lei
              que estabelece regras ao uso de dados pessoais de pessoas físicas por
              entidades públicas e privadas. A LGPD é uma norma que garante direitos aos
              titulares dos dados e estabelece uma regra mínima para coleta,
              armazenamento, tratamento e compartilhamento de dados pessoais de pessoas
              físicas.
            </p>
            <p
              style={{
                marginTop: "0pt",
                marginBottom: "8pt",
                textAlign: "justify",
                lineHeight: "150%"
              }}
            >
              As regras estabelecidas pela LGPD devem ser observadas por todos os setores
              do mercado: bancos, hospitais, comércios, empresas de e-commerce e também o
              terceiro setor.
            </p>
            <p style={{ marginTop: "0pt", marginBottom: "8pt", textAlign: "justify" }}>
              <strong>
                <span style={{ fontFamily: '"Malgun Gothic"' }}>IMPORTANTE:</span>
              </strong>
              <span style={{ fontFamily: '"Malgun Gothic"' }}>
      {" "}
                Esta Política foi alterada pela última vez e publicada no sistema em 13 de
      abril de 2025
    </span>
            </p>
          </>

        </div>
      </div>
    </>
  );
}

export default TermsOfUse;